import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators'
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment'
import { ErrorMessageComponent } from '../shared/error-message/error-message.component';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private isProcessing          : boolean = false;
  private numberOfCalls         : number  = 0;
  private actualNumberOfCalls   : number  = 0;

  //each group of calls are tagged together by action, that is specified by the caller.
  //the caller can take action by matching the tag
  private m_tag                 : string  = "";

  constructor(private httpClient : HttpClient) { }

  tag()         : string  { return this.m_tag; }
  processing()  : boolean { return this.isProcessing;}

  startCallGroup(numberOfCalls:number,p_tag : string){
    this.isProcessing         = false;
    this.numberOfCalls        = numberOfCalls;
    this.actualNumberOfCalls  = 0;
    this.m_tag                = p_tag;
  }

  endCallGroup() {
    if(this.numberOfCalls == this.actualNumberOfCalls) {

      setTimeout(() => {
        this.isProcessing         = false;
        this.numberOfCalls        = 0;
        this.actualNumberOfCalls  = 0;
        this.m_tag                = "";
      }, 2500);
     
    }
  }

  startCall() {
    this.isProcessing = true;
  }

  endCall() {
    this.actualNumberOfCalls++;

    this.endCallGroup();
  }

  get(url: string,errorComponent:ErrorMessageComponent,headers?:any):  Observable<any> {
    this.startCall();

    let result = this.httpClient.get(url,
      {
        headers:headers
      }).pipe(
        map((res: any) => {
          this.endCall();
          return res;
        }),
        catchError((error:HttpErrorResponse) =>{
          this.endCall();
          errorComponent.handleError(error);
          return throwError(error);
        }));

    return result;
  }

  post(url: string, body:any,errorComponent:ErrorMessageComponent,headers?:any): Observable<any> {
    this.startCall();

    let result = this.httpClient.post(url,body,
      {
        headers:headers
      }
      ).pipe(
        map((res: any) => {
            this.endCall();
            return res;
          }),
        catchError((error:HttpErrorResponse) =>{
          this.endCall();
          errorComponent.handleError(error);
          return throwError(error);
        }));

    return result;
  }
  
}
